var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 159 27",
    width: 159,
    height: 27,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "synctime1-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #2c7f75 } \n\t\t.s1 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m8.1 24.2q-2.1 0-3.8-0.7-1.6-0.8-2.6-2.1-1-1.4-1-3.2h3.7q0.1 1.4 1.1 2.3 0.9 0.8 2.6 0.8 1.8 0 2.8-0.8 1-0.9 1-2.2 0-1.1-0.7-1.7-0.6-0.7-1.5-1.1-0.9-0.3-2.5-0.7-2-0.6-3.3-1.1-1.3-0.6-2.2-1.8-0.9-1.1-0.9-3.1 0-1.8 0.9-3.1 0.9-1.4 2.5-2.1 1.6-0.7 3.8-0.7 3 0 4.9 1.5 2 1.5 2.2 4.2h-3.8q-0.1-1.2-1.1-2-1-0.8-2.6-0.8-1.5 0-2.4 0.7-0.9 0.8-0.9 2.2 0 1 0.5 1.6 0.6 0.6 1.5 1 0.9 0.3 2.5 0.7 2.1 0.6 3.4 1.2 1.3 0.5 2.2 1.7 0.9 1.2 0.9 3.2 0 1.6-0.9 3-0.8 1.4-2.4 2.3-1.7 0.8-3.9 0.8zm26.7-21.1l-6.9 13.3v7.6h-3.4v-7.6l-6.9-13.3 3.8 0.1 4.8 10.2 4.8-10.2zm19.9 20.8h-3.5l-10.2-15.6v15.6h-3.5v-20.9h3.5l10.2 15.6v-15.6h3.5zm3.3-10.4q0-3.1 1.4-5.5 1.5-2.5 3.9-3.8 2.5-1.4 5.4-1.4 3.3 0 5.9 1.7 2.6 1.6 3.8 4.6h-4.1q-0.9-1.7-2.3-2.5-1.4-0.8-3.3-0.8-2.1 0-3.7 0.9-1.6 1-2.6 2.7-0.9 1.7-0.9 4.1 0 2.3 0.9 4 1 1.7 2.6 2.7 1.6 0.9 3.7 0.9 1.9 0 3.3-0.8 1.4-0.8 2.3-2.4h4.1q-1.2 3-3.8 4.6-2.6 1.6-5.9 1.6-3 0-5.4-1.3-2.4-1.4-3.9-3.9-1.4-2.4-1.4-5.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m84 0h75v27h-75z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m103 2.9v4.1h-5.6v17h-5.1v-16.9l-5.6-0.1v-4.1zm7.7 0v21.1h-5.1v-21.1zm27.6 0v21.1h-5.2v-12.6l-4.7 12.6h-4.1l-4.8-12.7v12.7h-5.1v-21.1h6.1l5.9 14.6 5.8-14.6zm8.9 4.1v4.3h6.8v4h-6.8v4.6h7.7v4.1h-12.9v-21.1h12.9v4.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5ff2d1fb998d8f41d248d40d76c6bca6.svg";
export { ForwardRef as ReactComponent };